const parseDigits = (inputValue: string) => (inputValue.match(/\d+/g) || []).join('');

export const formatCprNumber = (cprNumber: string) => {
    const digits = parseDigits(cprNumber);
    const chars = digits.split('');
    return chars.reduce((r, v, index) => (index === 6 ? `${r}-${v}` : `${r}${v}`), '').substr(0, 11);
};
